import React from 'react';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import ChangeIndicator from '@atlassian/jira-portfolio-3-portfolio/src/common/view/change-indicator';
import { colourByOptions } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/colours';
import { DEPENDENCY_SETTINGS } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import ColorByLegend from './color-by-legend';
import ExportDate from './export-date';
import IssueTypesLegend from './issue-types-legend';
import messages from './messages';
import ReleaseLegend from './release-legend';
import ScenarioChangesLegend from './scenario-changes-legend';
import StatusBreakdownLegend from './status-breakdown-legend';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import SystemIconsLegend from './system-icons-legend';
import type { Props } from './types';

function Legend({
	intl,
	issueTypeLegendItems = [],
	dependencySettings = { display: DEPENDENCY_SETTINGS.DEFAULT },
	colorByValue = colourByOptions.NONE,
	customFields = [],
	colorByLegends = [],
	timelineWidth = 0,
	fieldColumnsViewSettings = { columns: [] },
	ChangeIndicatorComponent = ChangeIndicator,
	ColorByLegendComponent = ColorByLegend,
	IssueTypesLegendComponent = IssueTypesLegend,
	SystemIconsLegendComponent = SystemIconsLegend,
	StatusBreakdownLegendComponent = StatusBreakdownLegend,
}: Props & {
	intl: IntlShape;
}) {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<section className={styles.legend}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<h5 className={styles.title}> {intl.formatMessage(messages.legendHeader)} </h5>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.content}>
				{/* @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps */}
				<IssueTypesLegendComponent issueTypeLegendItems={issueTypeLegendItems} />
				<ReleaseLegend />

				<ColorByLegendComponent
					// @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps
					colorByValue={colorByValue}
					customFields={customFields}
					colorByLegends={colorByLegends}
					timelineWidth={timelineWidth}
				/>

				<StatusBreakdownLegendComponent
					// @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps
					fieldColumnsViewSettings={fieldColumnsViewSettings}
				/>
				<ScenarioChangesLegend ChangeIndicatorComponent={ChangeIndicatorComponent} />
				{/* @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps */}
				<SystemIconsLegendComponent dependencySettings={dependencySettings} />
			</div>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.footer}>
				<ExportDate />
			</div>
		</section>
	);
}

export default injectIntl(Legend);
